import React from 'react'
import ReactDOM from 'react-dom'
import { applyMiddleware, compose, createStore } from 'redux'
import { Provider } from 'react-redux'
import createSagaMiddleware from 'redux-saga'
import { Route } from 'react-router-dom'
import { ConnectedRouter, routerMiddleware } from 'react-router-redux'
import registerServiceWorker from './registerServiceWorker'

import './index.css'
import history from './history'
import dcpReducers from './reducers'
import sagas from './sagas'
import './i18n'
import App from './App'
import Logger from './components/common/logger'


const renderTopLevelRoutes = () => (
  <ConnectedRouter history={history}>
    <div>
      <Route path="/" component={App} />
    </div>
  </ConnectedRouter>
)

// Store / Middleware
const sagaMiddleware = createSagaMiddleware()
const storeMiddleware = [
  routerMiddleware(history),
  sagaMiddleware
]
// https://github.com/zalmoxisus/redux-devtools-extension
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const store = createStore(
  dcpReducers,
  composeEnhancers(
    applyMiddleware(...storeMiddleware)
  )
)
sagaMiddleware.run(sagas)

ReactDOM.render(
  <Provider store={store}>
    <Logger>
      {renderTopLevelRoutes()}
    </Logger>
  </Provider>,
  document.getElementById('root')
)

registerServiceWorker()


// WEBPACK FOOTER //
// ./src/index.js